import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { InputText } from 'primereact/inputtext';
import { ManufacturerAdminModel } from "../../../models/manufacturer";
import ManufacturerService from '../../../services/manufacturerService';
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import Language from '../../../common/components/language/language';
import { Lang } from '../../../common/enums';
import { InputTextarea } from 'primereact/inputtextarea';

interface IProps {
	saveClick: any,
	cancelClick: any,
	isVisible: boolean,
	currentManufacturer: ManufacturerAdminModel
}

interface IState {
	manufacturer: ManufacturerAdminModel,
	validationMessage: string,
	selectedLangId: number
}

class ManufacturerAddEditDialog extends React.Component<IProps, IState> {

	manufacturerService = new ManufacturerService();

	constructor(props: IProps) {
		super(props);

		this.state = {
			manufacturer: props.currentManufacturer,
			validationMessage: '',
			selectedLangId: Lang.bg
		};
	}

	handleChange = (key, value) => {
		const manufacturer: ManufacturerAdminModel = { ...this.state.manufacturer };
		manufacturer[key] = value;
		this.setState({ manufacturer: { ...manufacturer } });
	};

	isValidAddEditForm() {
		let message = '';

		this.setState({
			validationMessage: ''
		});

		if (!this.state.manufacturer.manufacturerContent.some(r => r.name != null)) {
			message += "Please enter 'Name'.<br />";
		}

		this.setState({
			validationMessage: message
		});

		return message == '';
	}

	handleSaveButton = event => {
		event.preventDefault();

		if (!this.isValidAddEditForm()) return;

		const manufacturer = this.state.manufacturer;

		this.props.saveClick(manufacturer);
	}

	handleCanselButton = () => {
		this.props.cancelClick();
	}

	onLangChange = (lang) => {
		this.setState({ selectedLangId: lang });
	}

	getValueContent = (key) => {
		let content = this.state.manufacturer.manufacturerContent.find(r => r.langId == this.state.selectedLangId)
		if (content && content[key]) {
			return content[key];
		}
		return '';
	}

	handleChangeContent = (key, value) => {
		const manufacturer: ManufacturerAdminModel = { ...this.state.manufacturer };
		let content = manufacturer.manufacturerContent.find(r => r.langId == this.state.selectedLangId);
		if (content) {
			content[key] = value;
		}
		this.setState({ manufacturer: { ...manufacturer } });
	};


	public render() {

		const { manufacturer, selectedLangId } = this.state;

		return (

			<Dialog header="Manufacturer Form" responsive={true} width="50%"
				modal={true}
				visible={this.props.isVisible}
				onHide={this.handleCanselButton}
				footer={
					<div>
						<Button label="Save" icon="pi pi-check" onClick={this.handleSaveButton} className="p-button-raised" />
						<Button label="Cancel" icon="pi pi-times" onClick={this.handleCanselButton} className="p-button-secondary p-button-raised" />
					</div>}
			>
				<div style={{ minHeight: '450px', maxHeight: '650px' }}>

					{this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
					<div className="p-grid p-fluid">
						<Language selectedLang={selectedLangId} onLangChange={this.onLangChange}></Language>
						<div className="p-g-12 p-md-12">
							<label>Name:</label>
							<InputText
								name="name"
								onChange={(e) => this.handleChangeContent('name', e.target['value'])}
								//onChange={this.handleInputChange}
								value={this.getValueContent('name')}
							/>
						</div>
						<div className="p-g-12 p-md-12">
							<label>Full Address:</label>
							<InputTextarea
								name="address"
								style={{ width: '100%' }}
								rows={5}
								onChange={(e) => this.handleChangeContent('address', e.target['value'])}
								value={this.getValueContent('address')}
							/>

						</div>
						{/* <div className="p-g-12 p-md-12">
							<label>City:</label>
							<InputText
								name="city"
								onChange={(e) => this.handleChangeContent('city', e.target['value'])}
								value={this.getValueContent('city')}
							/>
						</div>
						<div className="p-g-12 p-md-12">
							<label>Country:</label>
							<InputText
								name="country"
								onChange={(e) => this.handleChangeContent('country', e.target['value'])}
								value={this.getValueContent('country')}
							/>
						</div> */}
						<div className="p-g-12 p-md-12">
							<label>Phone:</label>
							<InputText
								name="phone"
								onChange={(e) => this.handleChange('phone', e.target['value'])}
								value={manufacturer && manufacturer.phone ? manufacturer.phone : ""}
							/>
						</div>
					</div>

				</div>
			</Dialog >
		)
	}
}

export default ManufacturerAddEditDialog;